module.exports = [
  {
    ru: 'Общая лексика',
    vocabularies: [
      {
        ru: 'да',
        de: 'Ja',
      },
      {
        ru: 'нет',
        de: 'Nein',
      },
      {
        ru: 'может быть',
        de: 'vielleicht',
      },
      {
        ru: 'пожалуйста',
        de: 'Bitte',
      },
      {
        ru: 'спасибо',
        de: 'Danke',
      },
      {
        ru: 'извините',
        de: 'Entschuldigung',
      },
      {
        ru: 'ясно, ладно',
        de: 'Alles klar',
      },
      {
        ru: 'Я (не) понимаю',
        de: 'Ich verstehe (nicht)',
      },
      {
        ru: 'Вы говорите по-немецки?',
        de: 'Sprechen Sie Deutsch?',
      },
      {
        ru: 'Я не говорю по-немецки',
        de: 'Ich spreche kein Deutsch',
      },
      {
        ru: 'Помогите!',
        de: 'Hilfe!',
      },
      {
        ru: 'Немного помедленнее, пожалуйста',
        de: 'Ein bisschen langsamer bitte',
      },
      {
        ru: 'Будь здоров(а)! Будьте здоровы!',
        de: 'Gesundheit!',
      },
      {
        ru: 'Твое (Ваше) здоровье!',
        de: 'Prost!',
      },
      {
        ru: 'где',
        de: 'Wo',
      },
      {
        ru: 'когда',
        de: 'Wann',
      },
      {
        ru: 'кто',
        de: 'Wer',
      },
      {
        ru: 'почему',
        de: 'Warum',
      },
    ],
  },
  {
    ru: 'Знакомство, как представиться',
    vocabularies: [
      {
        ru: 'имя',
        de: 'Name',
      },
      {
        ru: 'Как Вас зовут?',
        de: 'Wie heißen Sie?',
      },
      {
        ru: 'Меня зовут...',
        de: 'Ich heiße…',
      },
      {
        ru: 'Я ...',
        de: 'Ich bin…',
      },
      {
        ru: 'Приятно с Вами познакомиться',
        de: 'Es ist schön Sie kennenzulernen',
      },
      {
        ru: 'Мне X лет',
        de: 'Ich bin X Jahre alt',
      },
      {
        ru: 'Я из ...',
        de: 'Ich komme aus…',
      },
      {
        ru: 'Сколько Вам лет?',
        de: 'Wie alt sind Sie?',
      },
      {
        ru: 'Где Вы работаете?',
        de: 'Wo arbeiten Sie?',
      },
      {
        ru: 'Откуда Вы?',
        de: 'Wo kommen Sie her?',
      },
      {
        ru: 'Что привело Вас сюда?',
        de: 'Was bringt Sie hierher?',
      },
      {
        ru: 'Как прошла Ваша поездка?',
        de: 'Wie war Ihre Reise?',
      },
      {
        ru: 'Вы хорошо проводите время?',
        de: 'Haben Sie eine gute Zeit?',
      },
      {
        ru: 'Что Вы думаете о ...?',
        de: 'Was halten Sie von …?',
      },
      {
        ru: 'Мои друзья зовут меня ...',
        de: 'Meine Freunde nennen mich …',
      },
      {
        ru: 'Мы знакомы?',
        de: 'Kennen wir uns?',
      },
      {
        ru: 'Это (имя)',
        de: 'Dies ist (Name)',
      },
      {
        ru: 'Как прошли Ваши выходные?',
        de: 'Wie war Ihr Wochenende?',
      },
    ],
  },
  {
    ru: 'Приветствие / Прощание',
    vocabularies: [
      {
        ru: 'Здорого',
        de: 'Hey',
      },
      {
        ru: 'Доброе утро',
        de: 'Guten Morgen',
      },
      {
        ru: 'Добрый день. Здравствуй(те)',
        de: 'Guten Tag',
      },
      {
        ru: 'Добрый вечер',
        de: 'Guten Abend',
      },
      {
        ru: 'Спокойной ночи',
        de: 'Gute Nacht',
      },
      {
        ru: 'Пока',
        de: 'Tschüss',
      },
      {
        ru: 'До свидания',
        de: 'Auf Wiedersehen',
      },
      {
        ru: 'Как у Вас дела?',
        de: 'Wie geht es Ihnen?',
      },
      {
        ru: 'хорошо',
        de: 'Gut',
      },
      {
        ru: 'плохо',
        de: 'Schlecht',
      },
      {
        ru: 'Привет',
        de: 'Hey / Hallo',
      },
      {
        ru: 'Как дела?',
        de: "Wie geht's?",
      },
      {
        ru: 'Что нового?',
        de: 'Was gibt’s neues?',
      },
      {
        ru: 'Рад(а) Вас видеть.',
        de: 'Schön Sie zu sehen.',
      },
      {
        ru: 'Приятно с Вами познакомиться',
        de: 'Nett Sie kennenzulernen',
      },
      {
        ru: 'Всего хорошего',
        de: "Mach's gut",
      },
      {
        ru: 'Давно не виделись',
        de: 'Lange nicht gesehen',
      },
      {
        ru: 'Как обстоят дела?',
        de: "Wie steht's?",
      },
    ],
  },
  {
    ru: 'В поездке',
    vocabularies: [
      {
        ru: 'Я бы хотел(а)...',
        de: 'Ich möchte gerne…',
      },
      {
        ru: 'Где здесь туалет?',
        de: 'Wo sind die Toilleten?',
      },
      {
        ru: 'Который час?',
        de: 'Wie spät ist es?',
      },
      {
        ru: 'Я ночую у ...',
        de: 'Ich übernachte bei…',
      },
      {
        ru: 'Я навещаю семью',
        de: 'Ich besuche Familie',
      },
      {
        ru: 'Я здесь на X дня (дней)',
        de: 'Ich bin hier für X Tage',
      },
      {
        ru: 'У вас есть карта?',
        de: 'Haben Sie eine Karte?',
      },
      {
        ru: 'загранпаспорт',
        de: 'Reisepass',
      },
      {
        ru: 'аэропорт',
        de: 'Flughafen',
      },
      {
        ru: 'порт, гавань',
        de: 'Hafen',
      },
      {
        ru: 'безопасность',
        de: 'Sicherheit',
      },
      {
        ru: 'самолёт',
        de: 'Flugzeug',
      },
      {
        ru: 'поезд',
        de: 'Zug',
      },
      {
        ru: 'корабль',
        de: 'Schiff',
      },
      {
        ru: 'велосипед',
        de: 'Fahrrad',
      },
      {
        ru: 'мотоцикл',
        de: 'Motorrad',
      },
      {
        ru: 'автобус',
        de: 'Bus',
      },
      {
        ru: 'лететь',
        de: 'fliegen',
      },
      {
        ru: 'ехать',
        de: 'fahren',
      },
      {
        ru: 'ходить под парусом',
        de: 'segeln',
      },
    ],
  },
  {
    ru: 'Описание пути',
    vocabularies: [
      {
        ru: 'слева',
        de: 'links',
      },
      {
        ru: 'справа',
        de: 'rechts',
      },
      {
        ru: 'здесь, тут',
        de: 'hier',
      },
      {
        ru: 'там',
        de: 'dort',
      },
      {
        ru: 'обратно, назад',
        de: 'zurück',
      },
      {
        ru: 'вверх',
        de: 'hoch',
      },
      {
        ru: 'вниз',
        de: 'runter',
      },
      {
        ru: 'прямо',
        de: 'geradeaus',
      },
      {
        ru: 'населённый пункт, место',
        de: 'Ort',
      },
      {
        ru: 'Где находится ...?',
        de: 'Wo ist…?',
      },
      {
        ru: 'Как мне пройти к ...?',
        de: 'Wie komme ich nach…?',
      },
      {
        ru: 'Я ищу улицу ... .',
        de: 'Ich suche ... Straße.',
      },
      {
        ru: 'за углом',
        de: 'um die Ecke',
      },
      {
        ru: 'далеко',
        de: 'weit',
      },
      {
        ru: 'недалеко от, близко от',
        de: 'in der Nähe von',
      },
      {
        ru: 'напротив',
        de: 'gegenüber von',
      },
      {
        ru: 'Идите за мной',
        de: 'Folgen Sie mir',
      },
      {
        ru: 'рядом с X',
        de: 'neben X',
      },
      {
        ru: 'проходить мимо',
        de: 'vorbeigehen',
      },
      {
        ru: 'между',
        de: 'zwischen',
      },
    ],
  },
  {
    ru: 'Время / даты',
    vocabularies: [
      {
        ru: 'сейчас',
        de: 'jetzt',
      },
      {
        ru: 'сегодня',
        de: 'heute',
      },
      {
        ru: 'завтра',
        de: 'morgen',
      },
      {
        ru: 'вчера',
        de: 'gestern',
      },
      {
        ru: 'секунда',
        de: 'Sekunde',
      },
      {
        ru: 'минута',
        de: 'Minute',
      },
      {
        ru: 'час',
        de: 'Stunde',
      },
      {
        ru: 'день',
        de: 'Tag',
      },
      {
        ru: 'неделя',
        de: 'Woche',
      },
      {
        ru: 'месяц',
        de: 'Monat',
      },
      {
        ru: 'год',
        de: 'Jahr',
      },
      {
        ru: 'рано',
        de: 'früh',
      },
      {
        ru: 'поздно',
        de: 'spät',
      },
      {
        ru: 'понедельник',
        de: 'Montag',
      },
      {
        ru: 'вторник',
        de: 'Dienstag',
      },
      {
        ru: 'среда',
        de: 'Mittwoch',
      },
      {
        ru: 'четверг',
        de: 'Donnerstag',
      },
      {
        ru: 'пятница',
        de: 'Freitag',
      },
      {
        ru: 'суббота',
        de: 'Samstag',
      },
      {
        ru: 'воскресенье',
        de: 'Sonntag',
      },
      {
        ru: 'весна',
        de: 'Frühling',
      },
      {
        ru: 'лето',
        de: 'Sommer',
      },
      {
        ru: 'осень',
        de: 'Herbst',
      },
      {
        ru: 'зима',
        de: 'Winter',
      },
      {
        ru: 'январь',
        de: 'Januar',
      },
      {
        ru: 'февраль',
        de: 'Februar',
      },
      {
        ru: 'март',
        de: 'März',
      },
      {
        ru: 'апрель',
        de: 'April',
      },
      {
        ru: 'май',
        de: 'Mai',
      },
      {
        ru: 'июнь',
        de: 'Juni',
      },
      {
        ru: 'июль',
        de: 'Juli',
      },
      {
        ru: 'август',
        de: 'August',
      },
      {
        ru: 'сентябрь',
        de: 'September',
      },
      {
        ru: 'октябрь',
        de: 'Oktober',
      },
      {
        ru: 'ноябрь',
        de: 'November',
      },
      {
        ru: 'декабрь',
        de: 'Dezember',
      },
      {
        ru: 'время',
        de: 'Uhrzeit',
      },
      {
        ru: 'десятилетие',
        de: 'Jahrzehnt',
      },
      {
        ru: 'столетие, век',
        de: 'Jahrhundert',
      },
    ],
  },
  {
    ru: 'Места',
    vocabularies: [
      {
        ru: 'супермаркет',
        de: 'Supermarkt',
      },
      {
        ru: 'больница',
        de: 'Krankenhaus',
      },
      {
        ru: 'банк',
        de: 'Bank',
      },
      {
        ru: 'гостиница, отель',
        de: 'Hotel',
      },
      {
        ru: 'бар',
        de: 'Bar',
      },
      {
        ru: 'аптека',
        de: 'Apotheke',
      },
      {
        ru: 'пляж',
        de: 'Strand',
      },
      {
        ru: 'ресторан',
        de: 'Restaurant',
      },
      {
        ru: 'булочная',
        de: 'Bäckerei',
      },
      {
        ru: 'автобусная остановка',
        de: 'Bushaltestelle',
      },
      {
        ru: 'церковь',
        de: 'Kirche',
      },
      {
        ru: 'кинотеатр',
        de: 'Kino',
      },
      {
        ru: 'заправочная станция (заправка)',
        de: 'Tankstelle',
      },
      {
        ru: 'музей',
        de: 'Museum',
      },
      {
        ru: 'полицейский участок',
        de: 'Polizeistation',
      },
      {
        ru: 'школа',
        de: 'Schule',
      },
      {
        ru: 'площадь',
        de: 'Platz',
      },
      {
        ru: 'зоопарк',
        de: 'Zoo',
      },
    ],
  },
  {
    ru: 'Покупки',
    vocabularies: [
      {
        ru: 'дорого',
        de: 'teuer',
      },
      {
        ru: 'дёшево',
        de: 'billig',
      },
      {
        ru: 'бесплатно',
        de: 'kostenlos',
      },
      {
        ru: 'Сколько это стоит?',
        de: 'Wie viel kostet das?',
      },
      {
        ru: 'кассир',
        de: 'Kassierer',
      },
      {
        ru: 'тележка / корзинка для покупок',
        de: 'Trolley / Warenkorb',
      },
      {
        ru: 'сумка',
        de: 'Tasche',
      },
      {
        ru: 'гарантия',
        de: 'Garantie',
      },
      {
        ru: 'право возврата товара',
        de: 'Rückgaberecht',
      },
      {
        ru: 'карта клиента',
        de: 'Kundenkarte',
      },
      {
        ru: 'квитанция с НДС',
        de: 'Mehrwertsteuer-Quittung',
      },
      {
        ru: 'скидка',
        de: 'Rabatt',
      },
      {
        ru: 'ряд',
        de: 'Gang',
      },
      {
        ru: 'полка',
        de: 'Regal',
      },
      {
        ru: 'примерочная кабина',
        de: 'Umkleidekabine',
      },
      {
        ru: 'поставка',
        de: 'Lieferung',
      },
      {
        ru: 'сезонная распродажа',
        de: 'Schlussverkauf',
      },
      {
        ru: 'Извините, Вы здесь работаете?',
        de: 'Entschuldigen Sie, arbeiten Sie hier?',
      },
    ],
  },
  {
    ru: 'В ресторане',
    vocabularies: [
      {
        ru: 'Столик на X человек(а), пожалуйста.',
        de: 'Einen Tisch für X Personen, bitte.',
      },
      {
        ru: 'Я бы хотел(а) заказать.',
        de: 'Ich würde gerne bestellen.',
      },
      {
        ru: 'Дайте меню, пожалуйста.',
        de: 'Kann ich bitte die Karte haben?',
      },
      {
        ru: 'Счёт, пожалуйста.',
        de: 'Die Rechnung bitte.',
      },
      {
        ru: 'завтрак',
        de: 'Frühstück',
      },
      {
        ru: 'обед',
        de: 'Mittagsessen',
      },
      {
        ru: 'ужин',
        de: 'Abendessen',
      },
      {
        ru: 'столовые приборы',
        de: 'Besteck',
      },
      {
        ru: 'салфетка',
        de: 'Serviette',
      },
      {
        ru: 'второй завтрак',
        de: 'Brunch',
      },
      {
        ru: 'основное блюдо',
        de: 'Hauptgang',
      },
      {
        ru: 'десерт',
        de: 'Dessert',
      },
      {
        ru: 'чаевые',
        de: 'Trinkgeld',
      },
      {
        ru: 'гарнир',
        de: 'Beilage',
      },
      {
        ru: 'напитки',
        de: 'Getränke',
      },
      {
        ru: 'шведский стол',
        de: 'So viel du essen kannst',
      },
      {
        ru: 'акция "счастливые часы"',
        de: 'Happy Hour',
      },
      {
        ru: 'закуски',
        de: 'Appetizer',
      },
    ],
  },
  {
    ru: 'В гостинице, в отеле',
    vocabularies: [
      {
        ru: 'номер, комната',
        de: 'Zimmer',
      },
      {
        ru: 'обслуживание номеров',
        de: 'Zimmerservice',
      },
      {
        ru: 'ванная комната',
        de: 'Badezimmer',
      },
      {
        ru: 'кровать',
        de: 'Bett',
      },
      {
        ru: 'спальня',
        de: 'Schlafzimmer',
      },
      {
        ru: 'этаж',
        de: 'Etage',
      },
      {
        ru: 'лифт',
        de: 'Aufzug',
      },
      {
        ru: 'стойка администратора (ресепшен)',
        de: 'Rezeption',
      },
      {
        ru: 'полотенце',
        de: 'Handtuch',
      },
      {
        ru: 'соседние комнаты',
        de: 'Nebenräume',
      },
      {
        ru: 'багаж',
        de: 'Gepäck',
      },
      {
        ru: 'посыльный',
        de: 'Page',
      },
      {
        ru: 'миникухня',
        de: 'Kochnische',
      },
      {
        ru: 'постельное бельё',
        de: 'Bettwäsche',
      },
      {
        ru: 'камердинер',
        de: 'Kammerdiener',
      },
      {
        ru: 'лобби',
        de: 'Lobby',
      },
      {
        ru: 'аванс',
        de: 'Anzahlung',
      },
      {
        ru: 'заселиться в гостиницу',
        de: 'Einchecken',
      },
      {
        ru: 'выехать из гостиницы',
        de: 'Auschecken',
      },
      {
        ru: 'бесплатно',
        de: 'Gratis',
      },
    ],
  },
  {
    ru: 'Числа',
    vocabularies: [
      {
        ru: 'один',
        de: 'Eins',
      },
      {
        ru: 'два',
        de: 'Zwei',
      },
      {
        ru: 'три',
        de: 'Drei',
      },
      {
        ru: 'четыре',
        de: 'Vier',
      },
      {
        ru: 'пять',
        de: 'Fünf',
      },
      {
        ru: 'шесть',
        de: 'Sechs',
      },
      {
        ru: 'семь',
        de: 'Sieben',
      },
      {
        ru: 'восемь',
        de: 'Acht',
      },
      {
        ru: 'девять',
        de: 'Neun',
      },
      {
        ru: 'десять',
        de: 'Zehn',
      },
      {
        ru: 'одиннадцать',
        de: 'Elf',
      },
      {
        ru: 'двенадцать',
        de: 'Zwölf',
      },
      {
        ru: 'тринадцать',
        de: 'Dreizehn',
      },
      {
        ru: 'четырнадцать',
        de: 'Vierzehn',
      },
      {
        ru: 'пятнадцать',
        de: 'Fünfzehn',
      },
      {
        ru: 'шестнадцать',
        de: 'Sechszehn',
      },
      {
        ru: 'семнадцать',
        de: 'Siebzehn',
      },
      {
        ru: 'восемнадцать',
        de: 'Achtzehn',
      },
      {
        ru: 'девятнадцать',
        de: 'Neunzehn',
      },
      {
        ru: 'двадцать',
        de: 'Zwanzig',
      },
      {
        ru: 'тридцать',
        de: 'Dreißig',
      },
      {
        ru: 'сорок',
        de: 'Vierzig',
      },
      {
        ru: 'пятьдесят',
        de: 'Fünfzig',
      },
      {
        ru: 'шестьдесят',
        de: 'Sechszig',
      },
      {
        ru: 'семьдесят',
        de: 'Siebzieg',
      },
      {
        ru: 'восемьдесят',
        de: 'Achzig',
      },
      {
        ru: 'девяносто',
        de: 'Neunzig',
      },
      {
        ru: 'сто',
        de: 'Hundert',
      },
      {
        ru: 'двести',
        de: 'Zweihundert',
      },
      {
        ru: 'тысяча',
        de: 'Tausend',
      },
      {
        ru: 'две тысячи',
        de: 'Zweitausend',
      },
      {
        ru: 'миллион',
        de: 'Million',
      },
      {
        ru: 'миллиард',
        de: 'Milliarde',
      },
      {
        ru: 'первая (первый)',
        de: 'erste(r)',
      },
      {
        ru: 'вторая (второй)',
        de: 'zweite(r)',
      },
      {
        ru: 'третья (третий)',
        de: 'dritte(r)',
      },
      {
        ru: 'четвёртая (четвёртый)',
        de: 'vierte(r)',
      },
      {
        ru: 'пятая (пятый)',
        de: 'fünfte(r)',
      },
      {
        ru: 'шестая (шестой)',
        de: 'sechste(r)',
      },
      {
        ru: 'седьмая (седьмой)',
        de: 'siebte(r)',
      },
    ],
  },
  {
    ru: 'Личные местоимения',
    vocabularies: [
      {
        ru: 'я',
        de: 'ich',
      },
      {
        ru: 'ты',
        de: 'du',
      },
      {
        ru: 'он',
        de: 'er',
      },
      {
        ru: 'она',
        de: 'sie',
      },
      {
        ru: 'оно',
        de: 'es',
      },
      {
        ru: 'мы',
        de: 'wir',
      },
      {
        ru: 'вы',
        de: 'ihr',
      },
      {
        ru: 'они',
        de: 'sie',
      },
    ],
  },
  {
    ru: 'Важные слова',
    vocabularies: [
      {
        ru: 'вещь, предмет',
        de: 'Ding',
      },
      {
        ru: 'безопасный',
        de: 'sicher',
      },
      {
        ru: 'и',
        de: 'und',
      },
      {
        ru: 'или',
        de: 'oder',
      },
      {
        ru: 'потому что',
        de: 'weil',
      },
      {
        ru: 'жизнь',
        de: 'Leben',
      },
      {
        ru: 'правительство',
        de: 'Regierung',
      },
      {
        ru: 'ребёнок',
        de: 'Kind',
      },
      {
        ru: 'фирма',
        de: 'Firma',
      },
      {
        ru: 'группа',
        de: 'Gruppe',
      },
      {
        ru: 'возраст',
        de: 'Alter',
      },
      {
        ru: 'луна (Himmelskörper, Vollmond), месяц (Neumond)',
        de: 'Mond',
      },
      {
        ru: 'солнце',
        de: 'Sonne',
      },
      {
        ru: 'машина, автомобиль',
        de: 'Auto',
      },
      {
        ru: 'книга',
        de: 'Buch',
      },
      {
        ru: 'мир',
        de: 'Welt',
      },
      {
        ru: 'семья',
        de: 'Familie',
      },
      {
        ru: 'друг',
        de: 'Freund',
      },
      {
        ru: 'закон',
        de: 'Gesetz',
      },
    ],
  },
  {
    ru: 'Человек / Тело',
    vocabularies: [
      {
        ru: 'мужчина',
        de: 'Mann',
      },
      {
        ru: 'женщина',
        de: 'Frau',
      },
      {
        ru: 'мальчик',
        de: 'Junge',
      },
      {
        ru: 'девочка',
        de: 'Mädchen',
      },
      {
        ru: 'рука',
        de: 'Arm',
      },
      {
        ru: 'рука, ладонь',
        de: 'Hand',
      },
      {
        ru: 'нога',
        de: 'Bein',
      },
      {
        ru: 'нога, ступня',
        de: 'Fuß',
      },
      {
        ru: 'глаз',
        de: 'Auge',
      },
      {
        ru: 'голова',
        de: 'Kopf',
      },
      {
        ru: 'мозг',
        de: 'Gehirn',
      },
      {
        ru: 'нос',
        de: 'Nase',
      },
      {
        ru: 'ухо',
        de: 'Ohr',
      },
      {
        ru: 'волос(ы)',
        de: 'Haar',
      },
      {
        ru: 'бровь',
        de: 'Augenbraue',
      },
      {
        ru: 'губы',
        de: 'Lippen',
      },
      {
        ru: 'палец (Pl. пальцы)',
        de: 'Finger',
      },
      {
        ru: 'скелет',
        de: 'Skelett',
      },
      {
        ru: 'кость (Pl. кости)',
        de: 'Knochen',
      },
      {
        ru: 'кожа',
        de: 'Haut',
      },
    ],
  },
  {
    ru: 'Важные глаголы',
    vocabularies: [
      {
        ru: 'быть',
        de: 'sein',
      },
      {
        ru: 'получать (получить)',
        de: 'bekommen',
      },
      {
        ru: 'давать (дать)',
        de: 'geben',
      },
      {
        ru: 'жить',
        de: 'leben',
      },
      {
        ru: 'делать',
        de: 'machen',
      },
      {
        ru: 'идти, ходить',
        de: 'gehen',
      },
      {
        ru: 'использовать',
        de: 'benutzen',
      },
      {
        ru: 'есть, кушать',
        de: 'essen',
      },
      {
        ru: 'думать',
        de: 'denken',
      },
      {
        ru: 'приходить (прийти)',
        de: 'kommen',
      },
      {
        ru: 'иметь',
        de: 'haben',
      },
      {
        ru: 'делать',
        de: 'tun',
      },
      {
        ru: 'говорить, сказать',
        de: 'sagen',
      },
      {
        ru: 'знать',
        de: 'wissen',
      },
      {
        ru: 'видеть, смотреть',
        de: 'sehen',
      },
      {
        ru: 'хотеть',
        de: 'wollen',
      },
      {
        ru: 'находить (найти)',
        de: 'finden',
      },
      {
        ru: 'рассказывать (рассказать)',
        de: 'erzählen',
      },
      {
        ru: 'спрашивать (спросить)',
        de: 'fragen',
      },
      {
        ru: 'пытаться, пробовать',
        de: 'versuchen',
      },
      {
        ru: 'звонить',
        de: 'anrufen',
      },
    ],
  },
  {
    ru: 'Важные прилагательные',
    vocabularies: [
      {
        ru: 'красивый',
        de: 'schön',
      },
      {
        ru: 'уродливый, некрасивый',
        de: 'hässlich',
      },
      {
        ru: 'высокий',
        de: 'hoch',
      },
      {
        ru: 'маленький',
        de: 'klein',
      },
      {
        ru: 'большой',
        de: 'groß',
      },
      {
        ru: 'новый',
        de: 'neu',
      },
      {
        ru: 'длинный, долгий',
        de: 'lang',
      },
      {
        ru: 'прекрасный, чудесный',
        de: 'großartig',
      },
      {
        ru: 'старый',
        de: 'alt',
      },
      {
        ru: 'молодой',
        de: 'jung',
      },
      {
        ru: 'другой',
        de: 'anders',
      },
      {
        ru: 'важный',
        de: 'wichtig',
      },
      {
        ru: 'плохой',
        de: 'schlecht',
      },
      {
        ru: 'весёлый',
        de: 'lustig',
      },
      {
        ru: 'серьёзный',
        de: 'ernst',
      },
      {
        ru: 'сильный',
        de: 'stark',
      },
      {
        ru: 'простой',
        de: 'einfach',
      },
      {
        ru: 'сложный, трудный, тяжёлый',
        de: 'schwer',
      },
      {
        ru: 'бедный',
        de: 'arm',
      },
      {
        ru: 'богатый',
        de: 'reich',
      },
    ],
  },
];
